import { Outlet, useLocation } from 'react-router-dom';

import { AppBar } from '../components/shell/AppBar';
import { BottomTabBar } from '../components/shell/BottomTabBar';

export function AppShell() {
  const location = useLocation();

  // 인증 페이지(/app/login, /app/onboarding)는 셸 UI 숨김
  const hideShell =
    location.pathname.startsWith('/app/login') ||
    location.pathname.startsWith('/app/onboarding');

  return (
    <div className="min-h-dvh flex flex-col bg-beauty-hero">
      {!hideShell && <AppBar />}
      <main className="flex-1 flex flex-col w-full mx-auto max-w-[430px] md:max-w-3xl px-4 pb-20 md:pb-6">
        <Outlet />
      </main>
      {!hideShell && <BottomTabBar />}
    </div>
  );
}
